import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ResetPassword from "@/pages/ResetPassword";
import AdsiDevelop from "@/pages/AdsiDevelop";
import Contact from "@/pages/Contact";
import LastNed from "@/pages/LastNed";
import Personvern from "@/pages/Personvern";
import VilkaarOgAnsvar from "@/pages/VilkaarOgAnsvar";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/adsi-develop" element={<AdsiDevelop />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/last-ned" element={<LastNed />} />
          <Route path="/personvern" element={<Personvern />} />
          <Route path="/vilkaar-og-ansvar" element={<VilkaarOgAnsvar />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
